import * as Yup from 'yup'

export const categoriesScheme = Yup.object().shape({
  name: Yup.string().required('Name is required')
})
